/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EnergyProviderResponse } from '../models/EnergyProviderResponse';
import type { EnergyProviderUpdateRequest } from '../models/EnergyProviderUpdateRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EnergyProvidersRoutesRepository {
  /**
   * Get All Utilities
   * Lists all energy providers.
   * @returns EnergyProviderResponse Successful Response
   * @throws ApiError
   */
  public static energyProvidersRoutesGetAllUtilities({
    authorization,
  }: {
    authorization?: string,
  }): CancelablePromise<Array<EnergyProviderResponse>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/energy-providers',
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Get Energy Provider
   * Get energy provider by id.
   * @returns EnergyProviderResponse Successful Response
   * @throws ApiError
   */
  public static energyProvidersRoutesGetEnergyProvider({
    id,
    authorization,
  }: {
    id: string,
    authorization?: string,
  }): CancelablePromise<EnergyProviderResponse> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/energy-providers/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
  /**
   * Update Energy Provider
   * Updates energy provider preferred vendor.
   * @returns EnergyProviderResponse Successful Response
   * @throws ApiError
   */
  public static energyProvidersRoutesUpdateEnergyProvider({
    id,
    requestBody,
    authorization,
  }: {
    id: string,
    requestBody: EnergyProviderUpdateRequest,
    authorization?: string,
  }): CancelablePromise<EnergyProviderResponse> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/energy-providers/{id}',
      path: {
        'id': id,
      },
      headers: {
        'authorization': authorization,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        404: `Not Found`,
        422: `Validation Error`,
      },
    });
  }
}
